import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ky',
    fullName: 'Kyrgyz',
    nativeName: 'Кыргызча',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Кереметтүү нерсе келе жатат",
    landing_subtitle: "ArgVoid колдонмо жана оюн иштеп чыгуу студиясы болуп саналат. Байланыштуу болуңуз, жакында жаңы нерселер болот!",
    select_language: "Тилди танда",
    search_placeholder: "Тилдерди издөө...",
    terms_title: "Тейлөө шарттары",
    policy_title: "Купуялык саясаты",
    cookies_title: "Cookie саясаты",
    terms_content: `
        <strong>1. Шарттарды кабыл алуу</strong><br>
        ArgVoidге кирүү менен, бул Тейлөө шарттары кабыл алынат. Бул шарттар макул болбосо, кызмат колдонулбашы керек.<br><br>

        <strong>2. Platform Usage</strong><br>
        ArgVoid жана анын тиркемелери маалыматтык жана чыгармачылык максаттар үчүн "кандай болсо, ошондой" берилет. Кызмат мыйзамдуу максаттарда гана колдонулушу керек.<br><br>

        <strong>3. Тыюу салынган жүрүм </strong><br>
        Сайттын чабал жерлерин колдонууга, спам жөнөтүүгө же инфраструктурага уруксатсыз кирүүгө аракет кылууга катуу тыюу салынат.<br><br>

        <strong>4. Disclaimer</strong><br>
        Платформа жана кызматтар эскертүүсүз каалаган убакта өзгөртүлүшү мүмкүн. Кызматтын иштөө убактысына же жеткиликтүүлүгүнө эч кандай кепилдик берилбейт.
    `,
    policy_content: `
        <strong>1. Маалымат жыйнагы</strong><br>
        Бул учурда платформа колдонуучунун аныктыгын текшерүүнү же каттоо эсебин түзүүнү талап кылбайт. Коноктордон жеке идентификациялоочу маалымат (мисалы, ысымдар же электрондук почта даректери) жигердүү чогултулбайт.<br><br>

        <strong>2. Колдонуу Data</strong><br>
        Сайт трафигин түшүнүү жана тиркемелерди жакшыртуу үчүн негизги, анонимдүү аналитика чогултулушу мүмкүн. Бул маалымат жеке колдонуучунун идентификациясына байланыштырылбайт.<br><br>

        <strong>3. Үчүнчү Тарап Кызматтары</strong><br>
        Үчүнчү тараптын провайдерлери хостинг жана аналитика кызматтары үчүн колдонулушу мүмкүн. Бул тиешелүү камсыздоочулардын купуялык практикасы алардын инфраструктурасында иштетилген анонимдүү маалыматтарды башкарат.<br><br>

        <strong>4. Data Security</strong><br>
        Платформаны коргоо үчүн акылга сыярлык коопсуздук чаралары көрүлүүдө. Бирок, Интернет аркылуу берүүнүн эч бир ыкмасы толугу менен коопсуз эмес.<br><br>
    `,
    cookies_content: `
        <strong>1. Cookie файлдары жана жергиликтүү сактагыч деген эмне? </strong><br>
        Cookie файлдары жана серепчинин локалдык сактагычы - бул баруулардагы конфигурациянын артыкчылыктарын эстеп калуу үчүн түзмөктө сакталган кичинекей маалымат файлдары.<br><br>

        <strong>2. Колдонуу максаты</strong><br>
        Browser LocalStorage конфигурация орнотууларын сактоо үчүн катуу колдонулат, мисалы: <br>
        - Тил артыкчылыктары<br>
        - Колдонуучу интерфейсинин конфигурациясы (мисалы, макет же тема орнотуулары) <br>
        - убактылуу колдонмо cache<br><br>

        <strong>3. Tracking </strong><br> жок
        Cookie файлдары жана жергиликтүү сактагыч жарнак же үчүнчү тараптын көз салуу максатында колдонулбайт. Бардык сакталган маалыматтар платформанын негизги функциялары үчүн гана колдонулат.<br><br>

        <strong>4. Control</strong><br>
        Браузердин дайындары каалаган убакта браузердин жөндөөлөрү аркылуу тазаланышы мүмкүн, ал бардык жергиликтүү конфигурацияларды баштапкы абалга келтирет.
    `,
    cookie_consent_text: "Сеансыңызды активдүү кармап туруу, тил тандооңузду сактоо жана башка ыңгайлаштырылган конфигурациялар сыяктуу веб-сайт функцияларын туура камсыз кылуу үчүн биз негизги кукилерди колдонобуз.",
    read_policy: "Cookie саясатын окуңуз",
    support_title: "Колдоо кызматы менен байланышыңыз",
    support_subject_label: "Тема",
    support_message_label: "Кабар",
    support_submit_button: "Кабар жөнөтүү",
    support_hint: "Эскертүү: Бул билдирүү жөнөтүү үчүн демейки электрондук почта колдонмоңузду ачат.",
    support_success_msg: "Электрондук почта колдонмоңуз ачылууда...",
    support_error_msg: "Билдирүү жөнөтүлбөй калды. Сураныч, кийинчерээк кайра аракет кылыңыз.",
    explorer_title: "Explorer",
    history_title: "тарых",
    animation_title: "Анимация",
    config_title: "Конфигурация",
    tool_mouse: "Тандоо (Ctrl+M)",
    tool_brush: "Brush (Ctrl+B)",
    tool_brush_mode: "Которуу режими (катуу/таза)",
    tool_eraser: "өчүргүч (Ctrl+E)",
    tool_brush_size: "Brush өлчөмүн тууралаңыз",
    tool_bucket: "Толтуруу (Ctrl+F)",
    tool_eyedropper: "Тамчылаткыч",
    tool_grid: "Тор (Ctrl+Shift+B)",
    tool_rotate: "Айландыруу (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Которуу (Ctrl+Shift+T)",
    label_width: "Туурасы",
    label_height: "Бийиктик",
    label_frames: "Кадрлардын саны",
    label_animation: "Анимация стили",
    label_background_color: "Фон түсү",
    label_interval: "Интервал",
    tool_anim_config: "Animation Configuration",
    label_new_width: "Жаңы Width",
    label_new_height: "Жаңы бийиктик",
    label_apply: "Колдонуу",
    label_colors: "Түстөр",
    label_size: "Өлчөмү",
    label_tolerance: "Сабырдуулук",
    val_horizontal: "Горизонталдуу",
    val_vertical: "Вертикалдуу",
    val_sequence: "Ырааттуулук",
    val_bounce: "Bounce",
    val_random: "Random",
    val_solid: "Катуу",
    val_clear: "Таза",
    action_add_sheet: "Жаңы баракча",
    action_import: "Импорттоо",
    action_export: "Экспорт",
    action_sort_projects: "Сорттоо",
    sort_date_old: "Эң эски Биринчи",
    sort_date_new: "Newest First",
    sort_name_az: "Аты-жөнү (А-Я)",
    sort_name_za: "Аты-жөнү (Z-A)",
    action_new_sprite: "Жаңы Sprite",
    action_new_project: "Жаңы долбоор",
    modal_save_all_title: "Бардык өзгөртүүлөрдү сактоо",
    modal_save_all_desc: "Сактоо үчүн активдерди тандаңыз:",
    modal_save_selected: "Тандалганды сактоо",
    action_saved: "Сакталган",
    modal_create_sprite_title: "Жаңы Sprite түзүү",
    modal_create_project_title: "Жаңы долбоор түзүү",
    modal_add_sheet_title: "Жаңы баракты кошуу",
    modal_rename_sheet_title: "Барактын атын өзгөртүү",
    modal_rename_sprite_title: "Sprite атын өзгөртүү",
    modal_delete_sprite_title: "Sprite жок кылуу",
    modal_delete_project_title: "Долбоорду жок кылуу",
    modal_delete_sheet_title: "Баракты жок кылуу",
    placeholder_sprite_name: "аты",
    placeholder_project_name: "аты",
    placeholder_sheet_name: "аты",
    placeholder_new_name: "Жаңы ысым",
    action_create: "Түзүү",
    action_add: "кошуу",
    action_rename: "Атын өзгөртүү",
    action_duplicate: "Дубликат",
    action_delete: "Жок кылуу",
    action_cancel: "Жокко чыгаруу",
    confirm_delete_sprite: "Бул спрайтты чын эле жок кылгыңыз келеби?",
    confirm_delete_project: "Бул долбоорду чын эле жок кылгыңыз келеби? Бардык спрайттар алынып салынат.",
    confirm_delete_sheet: "Бул баракты чын эле жок кылгыңыз келеби?",
    err_select_sprite: "Сураныч, адегенде спрайт тандаңыз.",
    err_select_project: "Сураныч, адегенде долбоорду тандаңыз.",
    err_name_empty: "Аты бош болбошу керек.",
    err_sprite_exists: "Мындай аталыштагы спрайт мурунтан эле бар.",
    err_project_exists: "Мындай аталыштагы долбоор мурунтан эле бар.",
    err_no_content: "Сактай турган мазмун жок.",
    err_no_changes: "Сактоо үчүн эч кандай өзгөртүүлөр жок.",
    err_delete_last_sheet: "Акыркы баракты жок кылуу мүмкүн эмес.",
    err_extract_frames: "Эч бир кадр чыгарылбай койду.",
    err_indexeddb: "Жергиликтүү сакталган жок. Сиздин браузер IndexedDB колдоого албашы мүмкүн.",
    msg_upload_success: "Ийгиликтүү жүктөлдү: {0}",
    msg_upload_failed: "Жүктөп берүү ишке ашкан жок: {0}",
    msg_save_success: "Сактоо ийгиликтүү.",
    msg_saving: "Сакталууда...",
    msg_multi_save_result: "Сакталган {0} актив. {1} ката.",
    menu_title: "Меню",
    menu_save: "Сактоо",
    menu_save_all: "Баарын сактоо",
    menu_support: "Колдоо кызматы менен байланышыңыз",
    label_local_storage: "Жергиликтүү сактагыч",
    label_sign_in: "Кирүү",
    modal_export_title: "Sprite экспорттоо",
    label_filename: "Шилтемелер аты",
    label_format: "Формат",
    action_export_confirm: "Экспорт",
};

export default translations;
